'use strict';

// // AngularJS
import "angular";
import "angular-ui-bootstrap";
import "angular-sanitize";
import 'angular-paginate-anything';

import Pikaday from 'pikaday';
import 'pikaday/css/pikaday.css';

//Flow
import {Flow} from "../lib/flowjs";
import "@flowjs/ng-flow/dist/ng-flow-standalone.min.js";

//import '../libs/paginate-anything.min.js'; 

var EwSiteApp = angular.module('EwSiteApp', ['flow', 'ui.bootstrap']);

EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
    // Utility function to get a cookie value
    function getJsCookieValue(a) {
		let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
		return b ? b.pop() : '';
	}

	flowFactoryProvider.defaults = {
		target: '',
		permanentErrors: [202, 404, 500, 501],
		maxChunkRetries: 1,
		chunkRetryInterval: 5000,
		simultaneousUploads: 1,
        singleFile: false,
		chunkSize: 2 * 1024 * 1024,
		forceChunkSize: true,
		testChunks: false
	};

    // Workaround for issue https://github.com/flowjs/ng-flow/issues/92
	flowFactoryProvider.factory = function (opts) {
		let Flow = require('@flowjs/flow.js/dist/flow.js');
		return new Flow(opts);
	};

	// Add XSRF header to upload requests
    if (typeof (secure_xsrf_name) != 'undefined') {
        var xsrf_token = getJsCookieValue(secure_xsrf_name);
        if (xsrf_token !== '') {
			flowFactoryProvider.defaults.headers = {};
            flowFactoryProvider.defaults.headers['X-' + secure_xsrf_name] = xsrf_token;
		}
	}

	flowFactoryProvider.on('fileSuccess', function (file, response) {
		file.response = angular.fromJson(response);
	});
}]);

EwSiteApp.config(['$provide', function ($provide) {
		$provide.decorator('$browser', ['$delegate', function ($delegate) {
				$delegate.onUrlChange = function () {};
				$delegate.url = function () {
					return "";
				};
				return $delegate;
			}]);
	}]);

EwSiteApp.filter('u2date', ['$filter', function ($filter) {
		return function (udate) {
			var format = 'yyyy-MM-dd';
			if (arguments[1]) {
				format = arguments[1];
			}
			return $filter('date')(udate * 1000, format);
		};
	}]);

EwSiteApp.controller('CommentsCtrl', [
	'$scope',
	'$http',
	'$attrs',
	'$log',
	'$window',
	function ($scope, $http, $attrs, $log, $window) {
		$scope.postUrl = '';
		$scope.getUrl = '';
		$scope.hash_key = '';
		$scope.isconfirm = false;
		$scope.errors = [];
		$scope.comments = {list: []};
		$scope.all_displayed = false;

		$scope.clearCommentsForm = function () {
			$scope.comment.name = "";
			$scope.comment.email = "";
			$scope.comment.comment = "";
			$scope.errors = [];
			$scope.commentform.$setPristine();
		};

		$scope.submit = function () {
			if ($scope.postUrl !== '') {
				$scope.isconfirm = false;
				$http({
					method: 'POST',
					url: $scope.postUrl + '?hash_key=' + $scope.hash_key,
					data: $scope.comment,
					xsrfCookieName: $scope.hash_key
				})
						.then(function (response) {
							var data = response.data;
							if (data.data && data.data.success) {
								$scope.clearCommentsForm();
								$scope.isconfirm = data.data.isconfirm;
								if (!$scope.isconfirm) {
									$scope.getList(1);
								}
							} else if (data.data && angular.isDefined(data.data.messages)) {
								$scope.errors = data.data.messages;
							}
							if (data.data && angular.isDefined(data.data.debug)) {
								$log.debug(data.data.debug);
							}
							if (!$scope.isconfirm) {
								$('html, body').animate({
									scrollTop: $(".comments_list").offset().top - 10
								}, 300);
							}
						})
						.catch(function (err) {
							$log.error('Comments submit failed:', err);
						});
			}
		};

		$scope.getList = function (getall) {
			if (getall == 1) {
				$scope.all_displayed = true;
			}
			if ($scope.getUrl !== '') {
				$http({
					method: 'GET',
					url: $scope.getUrl + '?getall=' + getall + ';hash_key=' + $scope.hash_key // NOTE: kept ';' as in original
				})
						.then(function (response) {
							var data = response.data;
							$scope.comments.list = data.list;
							if (getall == 0 && data.totalRows <= $scope.limit) {
								$scope.all_displayed = true;
							}
						})
						.catch(function (err) {
							$log.error('Comments load failed:', err);
						});
			}
		};

		$scope.hasErrors = function () {
			return $scope.errors.length > 0;
		};
	}
])

		.directive('commentsContainer', [function () {
				return {
					restrict: 'A',
					link: function (scope, element, attr) {
						scope.postUrl = '';
						scope.getUrl = '';
						scope.hash_key = '';
						scope.limit = 10;

						if (attr.postUrl !== '') {
							scope.postUrl = attr.postUrl;
						}
						if (attr.id !== '') {
							scope.hash_key = attr.id;
						}
						if (attr.limit !== '') {
							scope.limit = attr.limit;
						}
						if (attr.getUrl !== '') {
							scope.getUrl = attr.getUrl;
							scope.getList(0);
						}
					}
				};
			}]);

EwSiteApp.service('ajaxSearch', [
	'$http',
	'$q',
	function ($http, $q) {
		return {
			search: search
		};

		function search(url) {
			var cfg = {
				method: 'GET',
				url: url
			};
			if (arguments[1]) {
				cfg.params = arguments[1];
			}
			var request = $http(cfg);
			return request.then(succesHandler, errorHandler);
		}

		function succesHandler(response) {
			return response.data;
		}

		function errorHandler(response) {
			if (!angular.isObject(response.data) || !response.data.message) {
				return $q.reject('An unknown error occurred.');
			}
			return $q.reject(response.data.message);
		}
	}
]);

EwSiteApp.controller('SuggestSearchCtrl', [
	'$scope',
	'$log',
	'$window',
	'ajaxSearch',
	function ($scope, $log, $window, ajaxSearch) {
		$scope.searchUrl = '';
		$scope.sdquery = '';
		$scope.searchresults = [];
		$scope.total = 0;
		$scope.search_url = '';
		$scope.templates = {
			title_description: 'search/title_description.html',
			img_title: 'search/img_title.html',
			img_title_description: 'search/img_title_description.html',
			module_gallery: 'search/module_gallery.html',
			module_youtubegallery: 'search/module_youtubegallery.html'
		};
		$scope.str_len = 100;

		$scope.find = function () {
			if ($scope.searchUrl !== '') {
				ajaxSearch.search($scope.searchUrl, {sdquery: $scope.sdquery}).then(function (results) {
					if ($scope.sdquery === '') {
						$scope.clear();
					} else {
						$scope.displaySuggestions(results);
						$scope.total = results.total;
						$scope.search_url = results.search_url;
					}
				}, function (response) {
					$log.error(response);
				});
			}
		};

		$scope.displaySuggestions = function (results) {
			$scope.searchresults = results.data;
		};

		$scope.clear = function () {
			$scope.sdquery = '';
			$scope.total = 0;
			$scope.displaySuggestions([]);
		};

		$scope.getDataTemplate = function (data) {
			if (data.module === 'gallery' || data.module === 'photoalbums') {
				data.display_options.template.id = 'module_gallery';
			}
			if (data.module === 'youtubegallery') {
				data.display_options.template.id = 'module_youtubegallery';
			}
			if (typeof (data.display_options.template.id) !== 'undefined' &&
					typeof ($scope.templates[data.display_options.template.id]) !== 'undefined') {
				return $scope.templates[data.display_options.template.id];
			}
			return $scope.templates.title_description;
		};

		$scope.changeLocationHash = function (data, name, varname) {
			var hash = '!' + name + data.display_options.vars[varname];
			$window.location.hash = hash;
		};
	}
]).directive('suggestSearchContainer', [function () {
		return {
			restrict: 'A',
			link: function (scope, element, attr) {
				scope.searchUrl = '';
				if (attr.searchUrl !== '') {
					scope.searchUrl = attr.searchUrl;
				}
			}
		};
	}]);

export {EwSiteApp};